import { environment } from '@environment';

export const busResultsApi = {
  bus_search: `${environment.api.netactica}/AirSearchV2/`,
  bus_results: `${environment.api.netactica}/AirResults/`,
  bus_grouped_results: `${environment.api.netactica}/AirGroupedResults/`,
  bus_filter: `${environment.api.netactica}/AirFilter/?searchId={searchId}`,
  bus_option: `${environment.api.netactica}/AirGroupedResults?sessionToken={sessionToken}&searchId={searchId}`
};
